export const oktaAuthConfig = {
  issuer: `https://${import.meta.env.VITE_APP_OKTA_BASE_URL}/oauth2/default`,
  clientId: import.meta.env.VITE_APP_OKTA_CLIENT_ID,
  redirectUri: `${window.location.origin}/login/callback`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true
};
